export default __webpack_public_path__ + "static/media/img-4.97211a44.jpg";